import clsx from "clsx";

import { FormControl } from "@components/forms";
import { type NorthbeamUtmPlatform } from "@features/utm-guide";
import { CopyButton as LibraryCopyButton } from "@shared/buttons/copy-button";
import TextBoxWithCopyButton from "@shared/text-box-with-copy-button";

import { getNorthbeamUtmPlatformParams } from "../constants";

export interface CopyUtmParamsProps {
  readonly platform: NorthbeamUtmPlatform;
  readonly hideQuestionMark?: boolean;
  readonly children?: string;
  className?: string;
  aggregateMultipleParams?: boolean;
}

export const CopyUtmParams = ({
  platform,
  hideQuestionMark,
  children = "Copy Parameters",
  aggregateMultipleParams = true,
  ...props
}: CopyUtmParamsProps) => {
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform,
  });

  const queryString = urlParamPairs
    .map(({ key, value }) => `${key}=${value}`)
    .join("&");

  const individualParamsBlocks = urlParamPairs.map(({ key, value }) => (
    <p key={key} className="inline-flex items-center font-bold card-text">
      {key}
      <TextBoxWithCopyButton
        className="pl-4"
        text={value}
        textCopiedNotificationMessage={`${key} parameter copied!`}
      />
    </p>
  ));

  return (
    <section
      {...props}
      className={clsx(
        "flex flex-col",
        aggregateMultipleParams ? "gap-3" : "gap-1",
        props.className,
      )}
    >
      {aggregateMultipleParams && (
        <>
          <LibraryCopyButton
            valueToCopy={queryString}
            style={{ maxWidth: "fit-content" }}
          >
            {children}
          </LibraryCopyButton>
          <FormControl
            as="textarea"
            rows={4}
            style={{ wordBreak: "break-all" }}
            value={hideQuestionMark ? queryString : `?${queryString}`}
            readOnly
          />
        </>
      )}
      {!aggregateMultipleParams && <>{individualParamsBlocks}</>}
    </section>
  );
};
